import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';

export class StatusDaysCount extends Model {
  @Expose() notOperational: number;
  @Expose() operational: number;
  @Expose() standBy: number;
  @Expose() underMaintenance: number;

  constructor() {
    super();
  }
}
